import * as React from 'react'

function Dots(props: any) {
  return (
    <svg {...props} width='10' height='14' viewBox='0 0 2 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='1' cy='1' r='1' fill='#C4C4C4' />
      <circle cx='1' cy='1' r='1' transform='translate(0 6)' fill='#C4C4C4' />
      <circle cx='1' cy='1' r='1' transform='translate(0 12)' fill='#C4C4C4' />
    </svg>
  )
}

export default Dots



// WEBPACK FOOTER //
// ./src/components/icons/ui/Dots.tsx